import React from 'react';

import { ShadedBox, ShadedBoxTitle } from '../BasePage';
import { IUEvent } from '../../lib/event';

import PhotosLink from './PhotosLink';

const AlbumDetails = ({ event }: { event: IUEvent }) => {
  const albumDetails = event.albumDetails;

  if (albumDetails === undefined) {
    return null;
  }

  return <ShadedBox>
    <ShadedBoxTitle>Photos {(albumDetails?.photoCount ?? 0) > 0 ? `(${albumDetails.photoCount})` : null}</ShadedBoxTitle>
    <PhotosLink event={event}/>
  </ShadedBox>;
};

export default AlbumDetails;
